import { push } from "connected-react-router";
import { startSubmit } from "redux-form";
import apiClient from "../../helpers/apiClient";
import { createLoadingSelector } from "./Loading";
import { getToken } from "./XsrfToken";

export const FETCH_VOUCHERS = "FETCH_VOUCHERS";
export const FETCH_VOUCHERS_REQUEST = "FETCH_VOUCHERS_REQUEST";
export const FETCH_VOUCHERS_SUCCESS = "FETCH_VOUCHERS_SUCCESS";
export const FETCH_VOUCHERS_FAILURE = "FETCH_VOUCHERS_FAILURE";

export const FETCH_VOUCHERS_REDEEMED = "FETCH_VOUCHERS_REDEEMED";
export const FETCH_VOUCHERS_REDEEMED_REQUEST =
  "FETCH_VOUCHERS_REDEEMED_REQUEST";
export const FETCH_VOUCHERS_REDEEMED_SUCCESS =
  "FETCH_VOUCHERS_REDEEMED_SUCCESS";
export const FETCH_VOUCHERS_REDEEMED_FAILURE =
  "FETCH_VOUCHERS_REDEEMED_FAILURE";

export const REDEEM_VOUCHERS = "REDEEM_VOUCHERS";
export const REDEEM_VOUCHERS_REQUEST = "REDEEM_VOUCHERS_REQUEST";
export const REDEEM_VOUCHERS_SUCCESS = "REDEEM_VOUCHERS_SUCCESS";
export const REDEEM_VOUCHERS_FAILURE = "REDEEM_VOUCHERS_FAILURE";

export const GET_VOUCHER_TYPE = "GET_VOUCHER_TYPE";
export const GET_VOUCHER_TYPE_REQUEST = "GET_VOUCHER_TYPE_REQUEST";
export const GET_VOUCHER_TYPE_SUCCESS = "GET_VOUCHER_TYPE_SUCCESS";
export const GET_VOUCHER_TYPE_FAILURE = "GET_VOUCHER_TYPE_FAILURE";

export const GET_VOUCHER_STATUS_SUCCESS = "GET_VOUCHER_STATUS_SUCCESS";

const initialState = {
  data: {},
  didLoaded: false,
  errorMessage: ""
};
export const loadingVouchersSelector = createLoadingSelector([FETCH_VOUCHERS]);
export const fetchVouchers = voucherStatus => dispatch => {
  return dispatch({
    types: [
      FETCH_VOUCHERS_REQUEST,
      FETCH_VOUCHERS_SUCCESS,
      FETCH_VOUCHERS_FAILURE
    ],
    callAPI: config =>
      apiClient.get(`Membership/GetVoucherList/${voucherStatus}`, config),
    payload: {}
  });
};

export const getVoucherType = () => dispatch => {
  return dispatch({
    types: [
      GET_VOUCHER_TYPE_REQUEST,
      GET_VOUCHER_TYPE_SUCCESS,
      GET_VOUCHER_TYPE_FAILURE
    ],
    callAPI: config => apiClient.get(`Voucher/GetVoucherType`, config),
    payload: {}
  });
};

export const fetchVouchersRedeem = voucherStatus => dispatch => {
  let voucherStatus = 1;
  return dispatch({
    types: [
      FETCH_VOUCHERS_REDEEMED_REQUEST,
      FETCH_VOUCHERS_REDEEMED_SUCCESS,
      FETCH_VOUCHERS_REDEEMED_FAILURE
    ],
    callAPI: config =>
      apiClient.get(`Membership/GetVoucherList/${voucherStatus}`, config),
    payload: {}
  });
};
export const redeemVouchers = (item, callback) => dispatch => {
  const dataRedeem = {
    VoucherTypeCode: item.voucherTypeCode,
    Qty: 1
  };
  return Promise.resolve(dispatch(startSubmit("redeem")))
    .then(() => dispatch(getToken()))
    .then(
      dispatch({
        types: [
          REDEEM_VOUCHERS_REQUEST,
          REDEEM_VOUCHERS_SUCCESS,
          REDEEM_VOUCHERS_FAILURE
        ],
        callAPI: config =>
          apiClient.post(
            `/Membership/GetVoucherWithPoints?VoucherTypeCode=${dataRedeem.VoucherTypeCode}&Qty=${dataRedeem.Qty}`,
            dataRedeem,
            config
          ),
        payload: {}
      })
    )
    .then(callback)
    .then(() => {
      return dispatch(push(`/rewards`));
    });
};
export const getVoucherStatus = voucherStatus => dispatch => {
  dispatch({
    type: GET_VOUCHER_STATUS_SUCCESS,
    payload: { voucherStatus: voucherStatus, errorMessage: "" }
  });
  return Promise.resolve();
};

export default function reducer(state = initialState, action) {
  const { payload, errorMessage, response } = action;
  switch (action.type) {
    case REDEEM_VOUCHERS_REQUEST:
    case FETCH_VOUCHERS_REQUEST:
      return {
        ...state,
        errorMessage: "",
        successMessage: ""
      };
    case REDEEM_VOUCHERS_SUCCESS:
    case FETCH_VOUCHERS_SUCCESS:
      return {
        ...state,
        data: response.data.result,
        didLoaded: true
      };
    case REDEEM_VOUCHERS_FAILURE:
    case FETCH_VOUCHERS_FAILURE:
      return {
        ...state,
        errorMessage
      };
    case FETCH_VOUCHERS_REDEEMED_REQUEST:
      return {
        ...state,
        errorMessage: "",
        successMessage: ""
      };
    case FETCH_VOUCHERS_REDEEMED_SUCCESS:
      // console.log("vouchersRedeemed:", response.data.result);
      return {
        ...state,
        vouchersRedeem: response.data.result,
        didLoaded: true
      };
    case FETCH_VOUCHERS_REDEEMED_FAILURE:
      return {
        ...state,
        errorMessage
      };
    case GET_VOUCHER_STATUS_SUCCESS:
      return {
        ...state,
        voucherStatus: payload.voucherStatus
      };
    case GET_VOUCHER_TYPE_SUCCESS:
      // console.log("vouchersType:", response.data.result);
      return {
        ...state,
        vouchersType: response.data.result.voucherTypeLists,
        didLoaded: true
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/modules/Voucher.js